import ApiService from 'services/ApiService'

const badRequestCode = 400;

export const DocumentsService = {
    getDocumentOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get('/document/Options/Document').then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getStorageBreakdown() {
        return new Promise((resolve, reject) => {
            ApiService.get('/document/Storage').then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        })
    },

    getLocationStorageBreakdown(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/document/Storage/LocationStats/search`,
                searchObject)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search location storage breakdown. Please try again later."
                            );
                        }
                    }
                );
        });
    },

    getDocumentTypes(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/document/DocumentTypes/search`,
                searchObject)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search documents. Please try again later."
                            );
                        }
                    }
                );
        });
    },

    getDocumentType(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/document/DocumentTypes/${id}`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },

    deleteDocumentType(documentId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/document/DocumentTypes/${documentId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject("Unable to delete document type, please try again.");
                });
        });
    },

    recoverDocumentType(documentId) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/document/DocumentTypes/${documentId}/Recover`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject("Unable to recover document type, please try again.");
                });
        });
    },

    createDocumentType(documentType) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/document/DocumentTypes`, documentType).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject("Unable to create document type. Please try again later.");
                    }
                }
            );
        });
    },

    updateDocumentType(id, documentType) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/document/DocumentTypes/${id}`, documentType).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject("Unable to update document type. Please try again later.");
                    }
                }
            );
        });
    },

    getDocumentTypeChangeLog(documentTypeId, pageSize, pageNumber, startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/document/DocumentTypes/${documentTypeId}/changelog?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },

    getDocumentDataRetention() {
        return new Promise((resolve, reject) => {
            ApiService.get('/document/Storage/DataRetention').then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateDocumentDataRetention(data) {
        return new Promise((resolve, reject) => {
            ApiService.put('/document/Storage/DataRetention', data).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDocuments(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/document/Documents/search`,
                searchObject)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search documents. Please try again later."
                            );
                        }
                    }
                );
        });
    },

    getDocument(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/document/Documents/${id}`).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },

    deleteDocument(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/document/Documents/${id}`).then(
                (response) => {
                    resolve(response.data);
                },
                () => {
                    reject("Unable to delete document, please try again.");
                });
        });
    },

    uploadDocument(document, entityId, documentTypeId) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("document", document);
        formData.append("entityId", entityId ?? '');
        formData.append("documentTypeId", documentTypeId);

        return new Promise((resolve, reject) => {
            ApiService.post(
                '/document/Documents/',
                formData,
                config
            ).then(function (response) {
                resolve(response);
            })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    getAccountsStorageOverview(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/document/Accounts/Storage/search`,
                searchObject)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search for storage overview. Please try again later."
                            );
                        }
                    }
                );
        });
    },
};